import { Fragment } from 'react';
import { ChevronRightIcon } from '@heroicons/react/16/solid';
import { clsx } from 'clsx';
import { Anchor } from '@components/common';
import { ApiBreadcrumbsOk } from '@type/v1-api-types';

// Interface
// ************************************
interface BreadcrumbsProps {
  breadcrumbs: ApiBreadcrumbsOk,
  className?: string,
}


/**
 * @description A component that is used to display breadcrumbs for SEO purposes.
 * - **breadcrumbs** - ApiBreadcrumbsOk - The breadcrumbs data.
 * - **className** - string - Optional additional class names for the component, for styling purposes.
 */

export const Breadcrumbs = (props: BreadcrumbsProps) => {
// Destructure props
  const {
    breadcrumbs, className,
  } = props;

  // Don't render if there are no items
  // *****************************************
  if (!breadcrumbs.items?.length) {
    return null;
  }

  // Render component
  // *****************************************
  return (
    <div className={clsx('mt-3', className)}>
      <ul className="scrollbar flex items-center space-x-1.5 overflow-x-auto pb-3">
        {breadcrumbs.items.map((item, itemIndex) => (
          <li className="flex shrink-0 items-center text-ink-medium" key={item.links.map((link) => link.label).join(',')}>
            {itemIndex > 0 && (
              <ChevronRightIcon className="mr-1.5 size-3.5 shrink-0" />
            )}
            {item.links.map((itemLink, linkIndex) => (
              <Fragment key={itemLink.label}>
                {itemLink.route ? (
                  <Anchor href={itemLink.route} styling="text" size="xs" className="!text-pico">
                    {itemLink.label}
                  </Anchor>
                ) : (
                  <span className="text-pico text-primary">
                    {itemLink.label}
                  </span>
                )}
                {linkIndex < item.links.length - 1 && (
                  <span className="mr-1 text-xs">,</span>
                )}
              </Fragment>
            ))}
          </li>
        ))}
      </ul>
    </div>
  );
};
